import React from 'react';

import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  deleteCarBrands,
  getSelectedCars,
  getStockBrandsAndModels,
  setCarBrand,
  setPage,
} from '@/store/reducers/cars-stock';
import { convertBrandsAndModelsToBrandsOptions } from '@/modules/CarsStock/components/common.helpers';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

function BrandFilter() {
  const dispatch = useTypedDispatch();
  const stockBrandsAndModels = useTypedSelector(getStockBrandsAndModels);
  const selectedBrands = useTypedSelector(getSelectedCars).selectedBrands;

  const isDisabledBrand =
    !!selectedBrands.length && stockBrandsAndModels.length === 1;
  const brandsOptions =
    convertBrandsAndModelsToBrandsOptions(stockBrandsAndModels);
  const isOneBrand = brandsOptions.length === 1;

  const handleChangeBrand = (brand: OptionType) => {
    dispatch(setCarBrand(brand));
    dispatch(setPage(1));
  };

  const handleClearBrand = () => {
    dispatch(deleteCarBrands());
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Марка"
      options={brandsOptions}
      selectedOptions={selectedBrands}
      widgetsOptions={{
        withoutSelected: isOneBrand,
        withoutClear: isOneBrand,
        withSearch: true,
      }}
      onChange={handleChangeBrand}
      onClear={handleClearBrand}
      disabled={isDisabledBrand}
    />
  );
}

export default BrandFilter;
